/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { OSKDocument } from '@oskey/core/types';

export enum OSKEntityType {
  entity = 'entity',
  subEntity = 'subEntity'
}

export type OSKEntityP = {
  organizationId: string;
  entityId: string;
  entityName: string;
  entityType: OSKEntityType.entity;
  subEntityIds: string[];
};

export type OSKSubEntity = {
  organizationId: string;
  entityId: string;
  entityName: string;
  entityType: OSKEntityType.subEntity;
  parentEntityId: string;
  propertiesIds: string[];
};

export type OSKEntity = OSKEntityP | OSKSubEntity;

export type OSKEntityDocument = OSKDocument<OSKEntity>;

export type OSKCreateEntity = {
  organizationAdminId?: string;
  organizationId: string;
  entityName: string;
  entityType: OSKEntityType;
  parentEntityId?: string;
  propertiesIds?: string[];
};
